import { render, staticRenderFns } from "./SurfaceNav.vue?vue&type=template&id=2c592378&scoped=true&"
import script from "./SurfaceNav.vue?vue&type=script&lang=js&"
export * from "./SurfaceNav.vue?vue&type=script&lang=js&"
import style0 from "./SurfaceNav.vue?vue&type=style&index=0&id=2c592378&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c592378",
  null
  
)

export default component.exports